export default __webpack_public_path__ + "static/media/p18.3d3e9bc8.jpg";